// removed by extract-text-webpack-plugin
module.exports = {"container":"_1j6z2JMBrAXzKFJtQO0Qkk","grid":"_7BnWskxs15nU1kLVcP5XG","chartContainer":"_3J5i4Xtg3mCUecrZFDCNAx","chart":"_1F7uHnjZFBwJ1oKDt1Jbk0","bar":"_8fqdkX33BWqwoJEhprF4g","value":"WicVyWp6n7gpkOHJl5weA","title":"_17DKJA422AIC6gmfiiEZIi","copy":"IUFPWBXQT6P0XR2h7emzd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BarChart/styles.css
// module id = 325
// module chunks = 0